<kendo-dialog title="{{title | translate}}" *ngIf="opened" (close)="opened=!opened" [minWidth]="250" [width]="width" [maxHeight]="'80vh'">
    <div class="py-4">
        <ng-container [ngTemplateOutlet]="modalContentTemplate"></ng-container>
    </div>
    <kendo-dialog-actions *ngIf="showDialogActions">
        <button kendoButton (click)="opened=!opened" translate fillmode="outline">{{cancelText | translate}}</button>
        <button kendoButton (click)="onConfirmButtonClicked()" fillmode="outline" themeColor="primary" translate> {{confirmText | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>